import type { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";

import InstitutionFormIdentityContext from "src/contexts/data/InstitutionFormIdentityContext";
import useInstitutionFormIdentityById from "src/hooks/data/load/useInstitutionFormIdentityById";

/**
 * Loads institution form identity from the matching route parameter for descendants.
 *
 * Preconditions: Render within the router that supplies the route parameters.
 * Postconditions: An absent or empty parameter becomes undefined; otherwise base-10 parseInt
 * supplies the ID, accepting numeric prefixes and producing NaN for unparseable text.
 * Loading and errors remain in context; this wrapper does not gate children or enforce access.
 * Assumptions: The loader handles request state and the server enforces authorization.
 */
export const RouteInstitutionFormIdentityProvider: FC<PropsWithChildren> = ({ children }) => {
    const { institutionFormId } = useParams<{ institutionFormId: string }>();
    const context = useInstitutionFormIdentityById(
        institutionFormId ? Number.parseInt(institutionFormId, 10) : undefined
    );

    return (
        <InstitutionFormIdentityContext.Provider value={context}>
            {children}
        </InstitutionFormIdentityContext.Provider>
    );
};
